<form no-validate (ngSubmit)="onSubmit(form)" [formGroup]="form">
    <ng-container *ngFor="let part of objectKeys(config);">
        <ng-container *ngIf="config[part].hasGroup || config[part].hasTemplate">
            <ng-container [ngTemplateOutlet]="this[part]" [ngTemplateOutletContext]="{ info: config[part] }"></ng-container>
        </ng-container>
    </ng-container>
</form>

<ng-template #login let-info="info">
    <div class="ctn login-ctn">
        <login-fieldset [group]="form.controls.login" [config]="info"></login-fieldset>
        <btnForm class="dt submit-btn e2e-btn-connexion" styleType="actionPrincipal" formType="submit" [disabled]="form.invalid">{{Yii.t('wui-shared-js',"Se connecter")}}</btnForm>
    </div>
</ng-template>
